import { DataOption } from '../../components'

export const TikTokDefaultMappings = [
  {
    cvFieldId: '',
    required: true,
    fieldName: 'campaign_id',
    type: 'integration_field',
  },
] as const

export const TikTokRequiredMappings = {
  campaigns: [
    {
      cvFieldId: '',
      required: true,
      fieldName: 'campaign_id',
      type: 'integration_field',
    },
  ],
  ads: [
    {
      cvFieldId: '',
      required: true,
      fieldName: 'ad_id',
      type: 'integration_field',
    },
  ],
  ad_groups: [
    {
      cvFieldId: '',
      required: true,
      fieldName: 'adgroup_id',
      type: 'integration_field',
    },
  ],
} as const

export const TikTokDataOptions = [
  {
    type: 'campaigns',
    label: 'Campaigns',
  },
  {
    type: 'ad_groups',
    label: 'Ad Groups',
  },
  {
    type: 'ads',
    label: 'Ads',
  },
] as const satisfies DataOption[]

export const TIKTOK_DATA_TYPE_KEY = 'data_type'
